import { createClient } from "@supabase/supabase-js";

// Cliente de Supabase Auth. La URL y la anon key son públicas (seguras en el bundle).
// Se pueden override por env (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY).
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://xdovkflucykoyjvtzgpm.supabase.co";

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhkb3ZrZmx1Y3lrb3lqdnR6Z3BtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0MTE5NTAsImV4cCI6MjA5Nzk4Nzk1MH0.xfNiihh6MGOiAb3XJnJV7xz3GU5W1NRyRgHEL5Mhs1I";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Mantener sincronizada la copia del access_token en sessionStorage ("Authorization")
// cada vez que Supabase lo refresca. Sin esto, el front seguía mandando el token viejo
// y a la ~1h una request daba 401 y deslogueaba. (No tocamos el flujo de recovery.)
supabase.auth.onAuthStateChange((event, session) => {
  if (
    (event === "SIGNED_IN" || event === "TOKEN_REFRESHED" || event === "INITIAL_SESSION") &&
    session?.access_token
  ) {
    sessionStorage.setItem("Authorization", session.access_token);
  }
});
